import { render, staticRenderFns } from "./initialSettings.vue?vue&type=template&id=dead2b12&scoped=true&"
import script from "./initialSettings.vue?vue&type=script&lang=js&"
export * from "./initialSettings.vue?vue&type=script&lang=js&"
import style0 from "./initialSettings.vue?vue&type=style&index=0&id=dead2b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead2b12",
  null
  
)

export default component.exports